import { render, staticRenderFns } from "./Scene.vue?vue&type=template&id=6748a6a0&scoped=true"
import script from "./Scene.vue?vue&type=script&lang=js"
export * from "./Scene.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6748a6a0",
  null
  
)

export default component.exports